import React, { useState } from 'react';
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, LogOut, Menu, X, ShieldCheck } from 'lucide-react';
const navItems = [{
  name: 'Dashboard',
  to: '/admin',
  icon: LayoutDashboard,
  end: true
}, {
  name: 'Members',
  to: '/admin/members',
  icon: Users,
  end: false
}];
export function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const SidebarContent = () => <div className="flex flex-col h-full" data-id="element-70">
      {/* Brand */}
      <div className="px-6 py-6 border-b border-white/10" data-id="element-71">
        <Link to="/admin" className="block" data-id="element-72">
          <span className="block font-serif text-lg text-white leading-tight" data-id="element-73">
            Andhra S. &amp; C. Association
          </span>
          <span className="text-[0.6rem] tracking-[0.25em] text-club-gold uppercase" data-id="element-74">
            Admin Console
          </span>
        </Link>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-6 space-y-1" data-id="element-75">
        {navItems.map(item => {
        const Icon = item.icon;
        return <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setMobileOpen(false)} className={({
          isActive
        }) => `flex items-center gap-3 px-4 py-3 rounded-sm text-sm font-medium transition-colors ${isActive ? 'bg-club-gold text-club-green' : 'text-club-canvas/80 hover:bg-white/10 hover:text-white'}`} data-id="element-76">
              <Icon size={18} data-id="element-77" />
              {item.name}
            </NavLink>;
      })}
      </nav>

      {/* Footer / logout */}
      <div className="px-3 py-4 border-t border-white/10" data-id="element-78">
        <button onClick={() => navigate('/admin/login')} className="w-full flex items-center gap-3 px-4 py-3 rounded-sm text-sm font-medium text-club-canvas/80 hover:bg-white/10 hover:text-white transition-colors" data-id="element-79">
          <LogOut size={18} data-id="element-80" />
          Logout
        </button>
      </div>
    </div>;
  return <div className="min-h-screen bg-club-canvas flex" data-id="element-81">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex w-64 bg-club-green flex-col fixed inset-y-0 left-0 z-30" data-id="element-82">
        <SidebarContent data-id="element-83" />
      </aside>

      {/* Mobile sidebar overlay */}
      {mobileOpen && <div className="lg:hidden fixed inset-0 z-40 flex" data-id="element-84">
          <div className="absolute inset-0 bg-club-navy/60" onClick={() => setMobileOpen(false)} data-id="element-85" />
          <aside className="relative w-64 bg-club-green flex flex-col" data-id="element-86">
            <SidebarContent data-id="element-87" />
          </aside>
        </div>}

      {/* Main column */}
      <div className="flex-1 lg:ml-64 flex flex-col min-h-screen" data-id="element-88">
        {/* Top bar */}
        <header className="sticky top-0 z-20 bg-white border-b border-club-border h-16 flex items-center justify-between px-4 sm:px-6" data-id="element-89">
          <div className="flex items-center gap-3" data-id="element-90">
            <button className="lg:hidden text-club-ink" onClick={() => setMobileOpen(true)} aria-label="Open navigation" data-id="element-91">
              <Menu size={22} data-id="element-92" />
            </button>
            <div className="flex items-center gap-2 text-club-green" data-id="element-93">
              <ShieldCheck size={18} className="text-club-gold" data-id="element-94" />
              <span className="font-serif text-lg" data-id="element-95">Member Administration</span>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-96">
            <div className="text-right hidden sm:block" data-id="element-97">
              <p className="text-sm font-medium text-club-ink leading-tight" data-id="element-98">
                Admin User
              </p>
              <p className="text-xs text-club-ink/50" data-id="element-99">Membership Office</p>
            </div>
            <div className="h-9 w-9 rounded-full bg-club-green text-club-gold flex items-center justify-center font-serif" data-id="element-100">
              A
            </div>
          </div>
        </header>

        {mobileOpen && <button className="lg:hidden fixed top-4 right-4 z-50 text-white" onClick={() => setMobileOpen(false)} aria-label="Close navigation" data-id="element-101">
            <X size={24} data-id="element-102" />
          </button>}

        {/* Page content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8" data-id="element-103">
          <Outlet data-id="element-104" />
        </main>
      </div>
    </div>;
}